<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="value" :filter="filter" :hide-delete="hideDelete" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover" />
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="filter" :card-color="cardColor" :readonly="readonly" :fields="fields" :title="formTitle" />
    </div>
</template>

<script>
    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'isHover'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase')
        },

        data() {
            return {
                roleForm: () => import('../forms/RoleForm'),
                userForm: () => import('../forms/UserForm'),
                fields: [
                    { type: 'autocomplete', text: 'User', value: 'userId', rules: [v => !!v || 'User is required'], isRequired: true, form: () => import('./UserForm'), apiMethod: 'Users', claim: 'Users' },
                    { type: 'autocomplete', text: 'Role', value: 'roleId', rules: [v => !!v || 'Role is required'], isRequired: true, form: () => import('./RoleForm'), apiMethod: 'Roles', claim: 'Roles' },
                ],
                apiMethod: 'UserRoles',
                formTitle: 'User Role',
            }
        },
    };
</script>
